import { render } from "./pc-item.vue?vue&type=template&id=cd0bf4b0&scoped=true&ts=true"
import script from "./pc-item.vue?vue&type=script&lang=ts"
export * from "./pc-item.vue?vue&type=script&lang=ts"

import "./pc-item.vue?vue&type=style&index=0&id=cd0bf4b0&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd0bf4b0"]])

export default __exports__